import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11843be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center"} }, " Text Input "),
    /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center","margin":"5px 0 0 10px","font-size":"8px"} })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"flex":"1"} }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_textarea, {
        value: _ctx.text,
        onInput: _ctx.onChange,
        placeholder: "Input text",
        style: {"height":"120px"}
      }, null, 8, ["value", "onInput"])
    ]),
    _: 1
  }))
}